import { Box, Button, CircularProgress, Stack, TextField } from "@mui/material";
import { useContext, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import { API_URL } from "../../app.config";
import Logo from "../../components/Logo";
import { useNotifications } from "../../components/Notification";
import GlobalContext from "../../global-context";
import { colors } from "../../helpers/colors";

export default function Login() {
  const globalContext = useContext(GlobalContext);
  const [searchParams] = useSearchParams();
  const { showNotification } = useNotifications();

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (globalContext.loggedIn) {
    const callbackUrl = searchParams.get("callbackUrl");
    if (callbackUrl) {
      return <Navigate to={callbackUrl} />;
    } else {
      return <Navigate to="/" />;
    }
  }

  return (
    <Box sx={{ width: "200px", margin: "20px auto" }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
      >
        <Stack sx={{ width: "300px" }} spacing={1}>
          <Logo color={colors.coralRed} size={60} />
          <span
            style={{
              textAlign: "center",
              fontSize: "11px",
              fontWeight: "bold",
              marginBottom: "30px",
            }}
          >
            Partner Portal
          </span>
          <TextField
            sx={{ backgroundColor: colors.white }}
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            type="password"
            sx={{ backgroundColor: colors.white }}
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            style={{
              backgroundColor: colors.coralRed,
              height: "40px",
              width: "60%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            variant="contained"
            disabled={!canLogin() || isLoading}
            onClick={handleLogin}
          >
            {isLoading ? (
              <CircularProgress color="inherit" size={25} />
            ) : (
              "Login"
            )}
          </Button>
        </Stack>
      </form>
    </Box>
  );

  function canLogin() {
    if (email === "") return false;
    if (password === "") return false;

    return true;
  }

  function handleLogin() {
    setIsLoading(true);

    fetch(`${API_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, password: password }),
    }).then(async (response) => {
      setIsLoading(false);

      if (response.status === 200) {
        const responseData = await response.json();

        localStorage.setItem(
          "user",
          JSON.stringify({
            userId: responseData.userId,
            userName: responseData.userName,
            userEmail: email,
            commissionPercentage: responseData.commissionPercentage,
            countryId: responseData.countryId,
            token: responseData.token,
          })
        );

        showNotification({
          severity: "success",
          message: "Successfully logged in",
        });
        globalContext.setLoggedIn(true);
      } else {
        showNotification({ severity: "error", message: "Login failed!" });
      }
    });
  }
}
